import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './styles/globals.css';
import { isNative } from './lib/platform';

// Tag the document on native so platform-conditional CSS (scroll lock,
// safe-area handling) can target it without each component checking JS.
if (isNative) document.documentElement.classList.add('is-native');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
